import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AccountVM } from '../../models/AccountMasterVM';
import { NetworkService } from '../infrastructure/network.service';
import { ConfigService } from '../infrastructure/config.service';

@Injectable({
  providedIn: 'root'
})
export class OrderTransferService {
  public SelectedAccountObj: BehaviorSubject<AccountVM>;

  constructor(private configService: ConfigService, private networkService: NetworkService) {
    this.SelectedAccountObj = new BehaviorSubject<AccountVM>(null);
  }

  public transferGrowerOrder(orderTransfer) {
    return this.networkService.postRequest(this.configService.saveG2GTransferUrl(), orderTransfer);
  }

  // Get allocation availability
  public getAllocationAvailability(data) {
    return this.networkService.postRequest(this.configService.getAllocationAvailabilityUrl(), data);
  }

  // Transfer to dealer order
  public transferDealerOrder(dealerOrderTransfer) {
    return this.networkService.postRequest(this.configService.saveD2DTransferUrl(), dealerOrderTransfer);
  }

  // Order transfer ->
  // Save Grower to Grower transfer from one Dealer to another
  public transferGrowerOrderToDifferentDealer(orderTransfer) {
    return this.networkService.postRequest(this.configService.saveG1D1G2D2FTansferUrl(), orderTransfer);
  }

  // Transfer to internal dealer order
  public transferInternalDealerOrder(dealerOrderTransfer) {
    return this.networkService.postRequest(this.configService.saveD2DinternalTransferUrl(), dealerOrderTransfer);
  }

  // Get allocation availability
  public getInternalAllocationAvailability(data) {
    return this.networkService.postRequest(this.configService.getInternalAllocationAvailabilityUrl(), data);
  }

  // Validate Transfer Dealer Order
  public validateTransferDealerOrder(data) {
    return this.networkService.postRequest(this.configService.validateTransferDealerOrderUrl(), data);
  }

  //validate Internal Transfer Dealer Order

  public validateInternalTransferDealerOrder(data) {
    return this.networkService.postRequest(this.configService.validateD2DinternalTransferUrl(), data);
  }

}
